import type { IListUserOption } from "@project/emerge-types";
import type { LTCaseUserOption } from "../enum/LTCaseUserOption";
import type { SurfaceType } from "./SurfaceType";

/** Material family for panel colors (display grouping). */
export enum PanelMaterialCategory {
  HoneycombPlastic = "Wabenkunststoff",
  BirchMultiplex = "Birkenmultiplex",
  PolyBoard = "Poly-Board",
}

/** Key for codesByThickness: use thickness as string, decimal as underscore (e.g. 6.5 → "6_5"). */
export function panelThicknessKey(strength: number): string {
  return String(strength).replace(".", "_");
}

// defines properties of panel materials used
export interface PanelColor
  extends IListUserOption<LTCaseUserOption.PanelColor> {
  boardSize: number[];
  color: string;
  /** Material family for grouping panel colors in configurators. */
  materialCategory: PanelMaterialCategory;
  /** Alternative detailed description */
  detailed?: string;
  metalic?: true;
  /**
   * Material code per panel thickness (Holzstärke).
   * Key = panelThicknessKey(strength), e.g. "6_5", "9", "10".
   * Used for pricing lookup.
   */
  codesByThickness?: Record<string, string>;
  /** Explicit surface type override (auto-inferred from description if not set) */
  surfaceType?: SurfaceType;
}
